<script>

    import { replace } from 'svelte-spa-router'

    import StorageService from '../$services/storage.service'
    import Quickview from '../$components/quickview.svelte'

    let show = false

    function showView(view) {
        replace(`#/${view}`);
    }

    function onLogout() {
        StorageService.deleteItem("user");
        StorageService.deleteItem("access");
        replace("#/");
    }

</script>

<div class="hero is-primary">
    <div class="hero-body">
        <div class="items-space">
            <div class="items-start">
                <span on:click={() => show = true} class="menu icon is-medium pointer">
                    <i class="fas fa-bars" ></i>
                </span>
                <div class="title">TIL</div>
            </div>
        </div>
    </div>
</div>

<Quickview title="Menú" bind:show>
    <div class="items-center">
        <div class="title">TIL</div>
    </div>
    <br>
    <div on:click={() => showView('home')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-home"></i>
        </span>
        <small>Inicio</small>
    </div>
    <br>
    <div on:click={() => showView('quotations')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-calculator"></i>
        </span>
        <small>Documentador</small>
    </div>
    <br>
    <div on:click={() => showView('shipments')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-shipping-fast"></i>
        </span>
        <small class="center">Envíos</small>
    </div>
    <br>
    <div on:click={() => showView('orders')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-clipboard-list"></i>
        </span>
        <small>Órdenes</small>
    </div>
    <br>
    <div on:click={() => showView('pickups')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-people-carry"></i>
        </span>
        <small>Recolecciones</small>
    </div>
    <br>
    <div on:click={() => showView('invoices')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-file-invoice-dollar"></i>
        </span>
        <small>Facturación</small>
    </div>
    <br>
    <div on:click={() => showView('accounts')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-file-invoice-dollar"></i>
        </span>
        <small>Cuentas consumo</small>
    </div>
    <br>
    <div on:click={() => showView('charges')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-file-invoice-dollar"></i>
        </span>
        <small>Cargos</small>
    </div>
    <br>
    <div on:click={() => showView('tickets')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-tag"></i>
        </span>
        <small>Tickets</small>
    </div>
    <br>
    <div on:click={() => showView('integrations')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-shopping-bag"></i>
        </span>
        <small>Integraciones</small>
    </div>
    <br>
    <div on:click={() => showView('accountsparcels')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-id-card"></i>
        </span>
        <small class="center">Cuentas propias</small>
    </div>
    <br>
    <div on:click={() => showView('settings')} class="item">
        <span class="icon is-medium">
            <i class="fas fa-cog"></i>
        </span>
        <small>Configuración</small>
    </div>
    <br>
    <div on:click={onLogout} class="item">
        <span class="icon is-medium">
            <i class="fas fa-sign-out-alt"></i>
        </span>
        <small>Salir</small>
    </div>
</Quickview>